.button {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  padding: 0;
  border: 1px solid transparent;
  border-radius: var(--radius-md);
  color: var(--color-text-2);
  transition:
    background-color var(--transition-fast),
    color var(--transition-fast);
}

.button:hover:not(:disabled) {
  color: var(--color-text);
}

.button:disabled {
  opacity: 0.55;
}

.secondary {
  background-color: var(--color-surface-2);
  border-color: var(--color-border-strong);
}

.secondary:hover:not(:disabled) {
  background-color: var(--color-surface-hover);
}

.ghost {
  background-color: transparent;
}

.ghost:hover:not(:disabled) {
  background-color: var(--color-surface-2);
}

.sm {
  width: var(--control-height-sm);
  height: var(--control-height-sm);
}

.md {
  width: var(--control-height-md);
  height: var(--control-height-md);
}
